export const TEA_PREDICTION_PAGE_TITLE = "Тест на настроение и чай Greenfield — найдите свой вкус лета";

export const TEA_PREDICTION_PAGE_DESCRIPTION =
	"Пройдите короткий тест Greenfield и получите персональное предсказание на день, рекомендацию чайного напитка и настроение, которое подходит именно Вам.";

export const TEA_PREDICTION_RESULT_PAGE_TITLE = "Ваше настроение дня найдено";

export const TEA_PREDICTION_RESULT_PAGE_DESCRIPTION =
	"Ваш результат готов! Получите персональное послание, узнайте свой чайный напиток Greenfield и откройте новый вкус этого лета.";

export const TEA_PREDICTION_TOKEN_KEY = "tea_prediction_token";

export const TEA_PREDICTION_SESSION_KEY = "tea_prediction_session";

export const teaPredictionQuestions = [
	{
		id: 1,
		text: "Как Вам хочется провести сегодняшний вечер?",
		affectsResult: true,
		answers: [
			{ id: "a", label: "Спокойно и без спешки", type: "BALANCE" },
			{ id: "b", label: "Спонтанно и ярко", type: "EASINESS" },
			{ id: "c", label: "В кругу близких людей", type: "SENSUALITY" },
		],
	},
	{
		id: 2,
		text: "Что сейчас нужно Вам больше всего?",
		affectsResult: true,
		answers: [
			{ id: "a", label: "Перезагрузка", type: "RESET" },
			{ id: "b", label: "Вдохновение", type: "ENTHUSIASM" },
			{ id: "c", label: "Тепло и уют", type: "BALANCE" },
		],
	},
	{
		id: 3,
		text: "Какой пейзаж Вам ближе?",
		affectsResult: true,
		answers: [
			{ id: "a", label: "Лес после дождя", type: "RESET" },
			{ id: "b", label: "Закат у моря", type: "EASINESS" },
			{ id: "c", label: "Огни вечернего города", type: "ENTHUSIASM" },
		],
	},
	{
		id: 4,
		text: "Ваш идеальный ритм сегодня:",
		affectsResult: true,
		answers: [
			{ id: "a", label: "Медленный", type: "BALANCE" },
			{ id: "b", label: "Активный", type: "ENTHUSIASM" },
			{ id: "c", label: "Умеренный", type: "SENSUALITY" },
		],
	},
	{
		id: 5,
		text: "Какое ощущение хочется сохранить после этого дня?",
		affectsResult: true,
		answers: [
			{ id: "a", label: "Спокойствие", type: "BALANCE" },
			{ id: "b", label: "Лёгкость", type: "EASINESS" },
			{ id: "c", label: "Вдохновлённость", type: "ENTHUSIASM" },
		],
	},
	{
		id: 6,
		text: "Откуда узнали о лаунж зоне Greenfield?",
		affectsResult: false,
		answers: [
			{ id: "a", label: "Реклама в интернете" },
			{ id: "b", label: "Email рассылка" },
			{ id: "c", label: "Другое" },
		],
	},
];
